<template>
    <div>
      <template v-if="!isTablet">
        <b-popover target="moveBtn" variant="light" triggers="click" placement="bottom">
          <template v-slot:title>
            Selecione a etapa que deseja mover este card
          </template>
          <b-form-select
          v-model="selectedOption"
          :options="options">
        </b-form-select>
        <DefaultButton btnVariant="btn-third justify-content-center" :onClick="confirmSelection" icon="fas fa-check-circle" text="Salvar" />
      </b-popover>
    </template>
    <template v-else>
      <b-modal scrollable centered :visible="true" :hide-footer="true" @hide="destroyModal" @close="destroyModal">
        <template #modal-title>
          Selecione a etapa que deseja mover este card
        </template>

        <template v-slot:title>
          Selecione a etapa que deseja mover este card
        </template>
        <b-form-select
        v-model="selectedOption"
        :options="options">
      </b-form-select>
      <DefaultButton btnVariant="btn-third justify-content-center" :onClick="confirmSelection" icon="fas fa-check-circle" text="Salvar" />
    </b-modal>
    </template>
      <EventManager v-if="columnEvents" :key="card.id" ref="EventManager" :eventsToShow="columnEvents" :card="card" @Submited="submitedEvents" @Aborted="abortedEvents"></EventManager>
    </div>
  </template>

<script>
import DefaultButton from '@/components/UI/button/defaultButton.vue'
import BoardColumnRepository from '@/shared/http/repositories/crm/boardcolumn.js'
import CardRepository from '@/shared/http/repositories/crm/card.js'
import EventManager from '@/views/private/crm/board/modal/event/EventManager.vue'
import { toast } from '@/shared/utils/UIHelper'

export default {
  name: 'MoveCardPopover',
  components: {
    DefaultButton,
    EventManager
  },
  props: {
    card: {
      type: Object,
      required: true
    },
    idCurrentBoard: {
      type: Number,
      required: true
    },
    boardColumns: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      selectedOption: null,
      options: [],
      eventsSubmited: false,
      columnEvents: null,
      isTablet: screen.width <= 1000
    }
  },
  mounted () {
    this.getBoardColumns(this.card.boardColumn.board.id)
  },
  methods: {
    destroyModal () {
      this.$emit('close')
    },
    getBoardColumns (boardId) {
      if (boardId) {
        BoardColumnRepository.Search(boardId)
          .then((res) => {
            this.boardColumns = res.data.content
            let sortedContent = res.data.content.sort((a, b) => a.posicao - b.posicao)
            let options = sortedContent.filter((x) => x.id != null).map((x) => ({'value': x.id, 'text': x.nome}))
            this.options = []
            options.forEach(option => {
              this.options.push(option)
            })
          })
          .catch(this.onException)
      }
    },
    submitedEvents (obj) {
      this.eventsSubmited = true
      this.confirmSelection()
    },
    abortedEvents () {
      this.columnEvents = null
    },
    confirmSelection () {
      this.onMoveCard(this.card, this.selectedOption, 1)
    },
    onMoveCard (card, newBoardColumnId, newIndex) {
      if (card) {
        let moveCardData = {
          id: card.id,
          newPosition: newIndex,
          newColumn: newBoardColumnId
        }

        let dataInicioSituacao = new Date().toISOString()
        let selectedBoard = this.boardColumns.filter(board => board.id === newBoardColumnId)
        let noObrigatoryEvent = !selectedBoard[0].eventoColuna.length || selectedBoard[0].eventoColuna.some((event) => event === 0)

        if (!noObrigatoryEvent && !this.eventsSubmited) {
          toast.warning(`Existem eventos obrigatórios cadastrados para a etapa selecionada!`, 'Atenção')
          this.columnEvents = selectedBoard[0].eventoColuna
          return
        }

        if (this.verifyRequiredColumns(this.idCurrentBoard, newBoardColumnId)) {
          CardRepository.MoveCard(moveCardData)
            .then((response) => {
              toast.info(`O Card foi movido!`, 'Sucesso!')
              this.$emit('moved', this.selectedOption, card, dataInicioSituacao)
            })
            .catch(this.onException)
        }
      }
    },
    verifyRequiredColumns (oldBoardColumnId, newBoardColumnId) {
      let newBoardColumnIndex = this.boardColumns.findIndex(c => c.id === newBoardColumnId)
      let oldBoardColumnIndex = this.boardColumns.findIndex(c => c.id === oldBoardColumnId)

      if (newBoardColumnIndex > oldBoardColumnIndex && (newBoardColumnIndex - oldBoardColumnIndex) > 1) {
        for (let i = (oldBoardColumnIndex + 1); i < newBoardColumnIndex; i++) {
          let passedBoardColumn = this.boardColumns[i]

          if (passedBoardColumn.obrigatorio === true) {
            toast.warning(`A passagem pela coluna ${passedBoardColumn.nome} é obrigatória!`)
            return false
          }
        }
      }

      return true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/crm/components/moveCardColumn/moveCardColumn.vue